import type { Action } from 'redux'
import * as types from '../types/refresh-jwt-types'

export const RefreshJwtRequest = (payload: {
  login: string
  userId: number
  companyId: number
}) => {
  return {
    type: types.REFRESH_JWT_REQUEST,
    payload,
  }
}

export const RefreshJwtSuccess = (payload: { token: string }): Action & { payload: { token: string } } => {
  return {
    type: types.REFRESH_JWT_SUCCESS,
    payload,
  }
}

export const RefreshJwtError = (payload: string): Action & { payload: string } => {
  return {
    type: types.REFRESH_JWT_ERROR,
    payload,
  }
}

export const RefreshJwtReset = (): Action => {
  return {
    type: types.REFRESH_JWT_RESET,
  }
}
